// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"266":"current-seminar","687":"archive-2025","838":"archive-2023"}[chunkId] || chunkId) + "." + {"266":"2bb8f600","523":"962978cf","687":"9c89a64c","838":"bf63611d","895":"326a43b8"}[chunkId] + ".js";
};